import API from '@/org-app/api';
import { createApiAction, createPostAction, createPutAction } from '@/utils/ActionsUtils';

export default {
  getJourneyAnalyses: createApiAction(
    API.instance.getOldJourneyAnalyses,
    null,
    'messages.failedToGetJourneyAnalysisForGeofenceGroups',
  ),
  getJourneyAnalysis: createApiAction(API.instance.getJourneyAnalysis, null, 'messages.failedToGetJourneyAnalysis'),
  updateJourneyAnalysis: createPutAction(
    API.instance.putOldJourneyAnalysis,
    null,
    'messages.failedtoUpdateJourneyAnalysis',
  ),
  createJourneyAnalysis: createPostAction(
    API.instance.postJourneyAnalysis,
    null,
    'messages.failedToCreateJourneyAnalysis',
  ),
  deleteJourneyAnalyses: createPostAction(
    API.instance.deleteJourneyAnalyses,
    null,
    'messages.failedToDeleteJourneyAnalysis',
  ),
};
